export const messages = {
  en: {
    allocationStorehouseHistoryAuditOrders: {
      title: 'Allocation History Audit Orders',
      back: 'Back',
      refresh: 'Refresh',
      allocationNumber: 'Allocation Number',
      allocationCount: 'Allocation Count',
      applicant: 'Applicant',
      status: 'Status',
      time: 'Time',
      operation: 'Operation',
      detail: 'Detail',
      fetchError: 'Failed to fetch allocation history audit orders'
    }
  },
  zh: {
    allocationStorehouseHistoryAuditOrders: {
      title: '调拨已办单',
      back: '返回',
      refresh: '刷新',
      allocationNumber: '调拨编号',
      allocationCount: '调拨数量',
      applicant: '申请人',
      status: '状态',
      time: '时间',
      operation: '操作',
      detail: '详情',
      fetchError: '获取调拨已办单失败'
    }
  }
}